






























































































































































































































































































































































































































































































import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import MStoreColumnFilter from '@/components/shared/Table/MStoreColumnFilter.vue';
import MStoreColumnConfiguration from '@/components/shared/Table/MStoreColumnConfiguration.vue';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import {
  BaseDocumentSearchModel,
  SearchCriteriaModel,
  StoreConstants,
  TableFilterModel,
  TableSortModel,
  SearchSplitConfiguration,
  DocumentViewerToolbarOptionsModel,
  DocumentViewerConstants,
  SearchResultsReferencePrefixes,
  ColourVariantType,
  ModalConstants,
  SearchTableStateModel
} from '@/types';
import { ColumnFilterType } from '@/types/enums/ColumnFilterType';
import { MStoreTableUtils, SearchCriteriaUtils, SelectableTableUtils } from '@/utils';
import { BvTableField } from 'bootstrap-vue';
import MStoreSplitter from '@/components/shared/MStoreSplitter.vue';
import Vue from 'vue';
import DocumentViewer from '@/components/shared/DocumentViewer.vue';
import { mapActions, mapGetters } from 'vuex';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { MStoreFormInput, PopOutSideBar } from '@/components/shared';
import ApiConfiguration from '@/classes/ApiConfiguration';
import SearchBuilder from '@/components/search/SearchBuilder.vue';
import { SearchResultsDocumentModel, SearchResultsModel, DocumentBulkEmailModel } from '@/services/GeneratedApi';
import { AppSettingsHelper } from '@/mixins/appSettingsHelper';
import MStoreSpinnerButton from '@/components/shared/MStoreSpinnerButton.vue';
import MStoreFormTextarea from '@/components/shared/MStoreFormTextarea.vue';
import { Search } from '@/types/constants/routes/search';
import { ValueType } from '@/types/enums/ValueType';
import { FormFieldValidation, ModalHelpers } from '@/mixins';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import MStoreSavedSearches from '@/components/shared/MStoreSavedSearches.vue';

export default Vue.extend({
  name: 'SearchResults',
  mixins: [AppSettingsHelper, FormFieldValidation],
  props: {
    refresh: {
      type: Boolean,
      default: false
    },
    savedSearchId: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      activeTab: 0,
      sortOptions: [],
      filterOptions: [],
      searchSaved: false,
      fields: [],
      documentBeingViewed: 0,
      isLoading: true,
      unsortedItems: [],
      editSearchData: false,
      exportOptions: DocumentViewerConstants.WithoutAcquiringLockExportOptions,
      isSearchRefreshing: false,
      isLinkActionActive: false,
      linkData: {},
      exportRequest: {},
      backgroundComponent: '',
      bulkDocuments: [],
      includeRelatedDocuments: false,
      isBulkEmailModalShown: false,
      bulkEmailModel: { to: '', subject: '', body: '', includeMe: false, documents: [] } as DocumentBulkEmailModel,
      isBulkEmailLoading: false,
      isBulkEmailProcessing: false,
      emailDocumentMaxCount: 20,
      forceRerender: false,
      isSaveSearchModalShown: false,
      isSavedSearchCreating: false,
      addSavedSearchModel: { name: '', isPrivate: true, roleId: null },
      savedSearchName: undefined,
      userRoles: [] as any[],
      isExportingToCsv: false
    };
  },
  computed: {
    ...mapGetters(StoreConstants.Search.ModuleName, [StoreConstants.Search.Getters.SearchCriteria, StoreConstants.Search.Getters.SearchResults]),
    ...mapGetters(StoreConstants.Oidc.ModuleName, [StoreConstants.Oidc.Getters.OidcUser]),
    ...mapGetters(StoreConstants.User.ModuleName, [StoreConstants.User.Getters.PreviousRoute]),
    ...mapGetters(StoreConstants.DocumentView.ModuleName, [StoreConstants.DocumentView.Getters.IsDeleting]),
    ...mapGetters(StoreConstants.UserPreferences.ModuleName, [
      StoreConstants.UserPreferences.Getters.SearchPinSort,
      StoreConstants.UserPreferences.Getters.SearchPinFilter,
      StoreConstants.UserPreferences.Getters.SearchSplitConfiguration
    ]),
    roleId: {
      get(this: any) {
        return this.addSavedSearchModel.roleId;
      },
      set(this: any, updatedValue: number | null | undefined) {
        this.addSavedSearchModel.roleId = updatedValue;
      }
    },
    pinSort: {
      get(this: any) {
        return this.searchPinSort;
      },
      set(this: any, updatedPinSort: boolean) {
        this[StoreConstants.UserPreferences.Actions.SetSearchPinSort]({ pinSort: updatedPinSort });
        this.forceSplitterRerender();
      }
    },
    pinFilter: {
      get(this: any) {
        return this.searchPinFilter;
      },
      set(this: any, updatedPinFilter: boolean) {
        this[StoreConstants.UserPreferences.Actions.SetSearchPinFilter]({ pinFilter: updatedPinFilter });
        this.forceSplitterRerender();
      }
    },
    filteredSortedItems(this: any) {
      const filteredItems = MStoreTableUtils.applyDefaultFiltering(this.unsortedItems, this.searchResults.appliedFilterOptions);
      const filteredSortedItems = MStoreTableUtils.applyDefaultSorting(filteredItems, this.searchResults.appliedSortOptions);
      return filteredSortedItems;
    },
    columns(this: any) {
      return (this.fields as Array<{ key: string } & BvTableField>).filter((x) => x.key !== 'actions');
    },
    orderedColumns(this: any) {
      const orderedColoums = MStoreTableUtils.applyDefaultColumnConfigurations(this.searchResults.response.columns, this.searchResults.columnOrders);
      return [
        { key: 'actions', label: '', tdClass: 'w-0 align-middle no-resize', thClass: 'w-0 no-resize' },
        { key: 'hasNotes', tdClass: 'w-0 p-2 align-middle no-resize', thClass: 'w-0 p-2 no-resize' },
        ...orderedColoums
      ];
    },
    searchReturnedNoMatches(this: any) {
      return this.unsortedItems.length === 0;
    },
    documentViewerToolbarOptions(this: any): DocumentViewerToolbarOptionsModel {
      const options: DocumentViewerToolbarOptionsModel = {
        allowPageNavigation: true,
        allowPageDelete: true,
        allowDocumentDelete: true,
        showEditReferences: true,
        pageDeleteNotAllowedTooltip: '',
        documentDeleteNotAllowedTooltip: ''
      };
      return options;
    },
    filteringFields(this: any) {
      return this.orderedColumns.filter((x: any) => x.key !== 'actions');
    },
    selectedDocumentCount(this: any): number {
      return this.searchResults.selectedItemKeys?.length ?? 0;
    },
    hasSelectedDocuments(this: any): boolean {
      return this.selectedDocumentCount > 0;
    },
    filteredSortedItemsCount(this: any): number {
      return this.filteredSortedItems?.length ?? 0;
    },
    isTableLoading(this: any) {
      return this.isSearchRefreshing || this[StoreConstants.DocumentView.Getters.IsDeleting];
    },
    selectedBulkDocuments(this: any) {
      return this.searchResults.response.documents.filter((d: SearchResultsDocumentModel) => this.searchResults.selectedItemKeys.includes(d.documentId!.toString()));
    },
    tableHeaderText(this: any) {
      const { resultsCount, totalResultsCount }: SearchResultsModel = this[StoreConstants.Search.Getters.SearchResults].response;
      if (!resultsCount) {
        return 'Search Results - No results found';
      }

      if (resultsCount === totalResultsCount) {
        return `Search Results - ${resultsCount} items`;
      }

      return `Search Results - showing first ${resultsCount} items`;
    },
    editSearch: {
      get(this: any) {
        return this.editSearchData;
      },
      set(this: any, newValue: boolean) {
        this.editSearchData = newValue;
        if (!newValue) {
          this.$refs.searchBuilder.initialiseSearch();
        }
      }
    },
    columnOrders: {
      get(this: any) {
        return this[StoreConstants.Search.Getters.SearchResults].columnOrders;
      },
      set(this: any, newValue: any) {
        this[StoreConstants.Search.Actions.SetColumnOrders](newValue);
      }
    }
  },
  methods: {
    ...mapActions(StoreConstants.DocumentView.ModuleName, ['setDocumentSearchModel', 'loadPage', 'retrieveDocumentActions', 'unloadDocument']),
    ...mapActions(StoreConstants.Search.ModuleName, [
      StoreConstants.Search.Actions.SetSearchCriteria,
      StoreConstants.Search.Actions.SetSelectedItems,
      StoreConstants.Search.Actions.SetCurrentPage,
      StoreConstants.Search.Actions.SetItemsPerPage,
      StoreConstants.Search.Actions.SetShowSorting,
      StoreConstants.Search.Actions.SetShowFilters,
      StoreConstants.Search.Actions.SetAppliedFilterOptions,
      StoreConstants.Search.Actions.SetAppliedSortOptions,
      StoreConstants.Search.Actions.SetColumnOrders,
      StoreConstants.Search.Actions.SetSplitConfiguration,
      StoreConstants.Search.Actions.SetSearchResponse,
      StoreConstants.Search.Actions.SetUnsortedItems,
      StoreConstants.Search.Actions.SetLastViewedDocument,
      StoreConstants.Search.Actions.UnloadSearchResults,
      StoreConstants.Search.Actions.ResetSearchResults
    ]),
    ...mapActions(StoreConstants.UserPreferences.ModuleName, [
      StoreConstants.UserPreferences.Actions.SetSearchPinSort,
      StoreConstants.UserPreferences.Actions.SetSearchPinFilter,
      StoreConstants.UserPreferences.Actions.SetSearchSplitConfiguration
    ]),
    ...mapActions(StoreConstants.ApplicationDirty.ModuleName, [StoreConstants.ApplicationDirty.Actions.ResetApplicationDirtyState]),
    onRowSelected(this: any, itemKey: string) {
      this[StoreConstants.Search.Actions.SetSelectedItems](SelectableTableUtils.DefaultSelectItem(this.searchResults.selectedItemKeys, itemKey));
    },
    onRowsSelected(this: any, itemKeys: string[]) {
      this[StoreConstants.Search.Actions.SetSelectedItems](SelectableTableUtils.DefaultSelectItems(this.searchResults.selectedItemKeys, itemKeys));
    },
    onPaginatedItemsUpdated(this: any, updatedItemKeys: string[]) {
      this[StoreConstants.Search.Actions.SetSelectedItems](SelectableTableUtils.DefaultTableItemsUpdated(this.searchResults.selectedItemKeys, updatedItemKeys));
    },
    updateTable(this: any, field: string, value: any) {
      if (value != null) {
        this.searchResults[field] = value;
      }
    },
    updateFilter(this: any, index: number, filter: TableFilterModel) {
      Vue.set(this.filterOptions, index, filter);
    },
    addFilter(this: any) {
      this.filterOptions = [...(this.filterOptions as TableFilterModel[]), { key: '', columnFilterType: ColumnFilterType.Like }] as TableFilterModel[];
    },
    clearFilters(this: any) {
      const filterFields: TableFilterModel[] = this.filterOptions;
      this.filterOptions = filterFields.map(({ key, columnFilterType }) => ({
        key,
        columnFilterType,
        value: ''
      }));
    },
    resetFilters(this: any) {
      this.filterOptions = [];
      this.applyFilters();
    },
    applyFilters(this: any) {
      this[StoreConstants.Search.Actions.SetAppliedFilterOptions]([...this.filterOptions]);
    },
    removeFilter(this: any, index: number) {
      this.filterOptions.splice(index, 1);
    },
    onSortingApplied(this: any) {
      this.sortItems();
    },
    updateSortItem(this: any, index: number, sortOption: TableSortModel) {
      Vue.set(this.sortOptions, index, { ...sortOption });
    },
    addSortItem(this: any, sortOption?: TableSortModel) {
      this.sortOptions.push(sortOption || { sortingKey: '', isSortingAscending: true });
    },
    deleteSortOption(this: any, index: number) {
      this.sortOptions.splice(index, 1);
    },
    resetSort(this: any) {
      this.sortOptions = [] as TableSortModel[];
      this.sortItems();
    },
    sortItems(this: any) {
      const usedFields = new Set();
      for (const option of this.sortOptions) {
        if (option.sortingKey === '') {
          SnotifyConfiguration.showError('Not all sorting options have a field selected');
          return;
        }

        if (usedFields.has(option.sortingKey)) {
          const columnDescription = this.queueColumns.find((x: any) => x.key === option.sortingKey).label;
          SnotifyConfiguration.showError(`Cannot sort on the same field (${columnDescription}) twice`);
          return;
        } else {
          usedFields.add(option.sortingKey);
        }
      }
      this[StoreConstants.Search.Actions.SetAppliedSortOptions]([...this.sortOptions]);
    },
    async forceSplitterRerender(this: any) {
      // DOT NOT REMOVE: This is a hack to force the splitter to rerender.
      // The splitter does not rerender when the search configuration updates within the mstore table.
      // Splitpanes is causing issues with reactivity.
      this.forceRerender = true;
      await Vue.nextTick();
      this.forceRerender = false;
    },
    viewDocument(this: any, item: any) {
      this.unloadDocument();

      const documentSearchModel: BaseDocumentSearchModel = {
        cabinetId: item.cabinetId,
        documentId: item.documentId,
        documentTypeId: item.documentTypeId
      };
      this.setDocumentSearchModel(documentSearchModel);
      this.documentBeingViewed = this.documentBeingViewed === item.documentId && this.searchResults.splitConfiguration !== SearchSplitConfiguration.HideDocument ? 0 : item.documentId;
      this[StoreConstants.Search.Actions.SetSplitConfiguration](
        this.searchResults.splitConfiguration === SearchSplitConfiguration.HideDocument ? SearchSplitConfiguration.Vertical : this.searchResults.splitConfiguration
      );
      this.retrieveDocumentActions();
      this[StoreConstants.Search.Actions.SetLastViewedDocument]({ cabinetId: item.cabinetId, documentId: item.documentId });
      this.loadPage(1);
    },
    referenceToolTip(this: any, item: any, field: any): string | undefined {
      if (!field) {
        return undefined;
      }

      if (field.key.startsWith(SearchResultsReferencePrefixes.CommonReference) && item.cabinetId) {
        return this.searchResults.response.commonReferenceDescriptions?.[item.cabinetId]?.[field.key];
      }

      if (field.key.startsWith(SearchResultsReferencePrefixes.DocumentReference) && item.documentTypeId) {
        return this.searchResults.response.documentReferenceDescriptions?.[item.documentTypeId]?.[field.key];
      }

      return undefined;
    },
    needsTooltip(field: any, value: string): boolean {
      if (!field || !value) {
        return false;
      }

      return field.key.startsWith(SearchResultsReferencePrefixes.CommonReference) || field.key.startsWith(SearchResultsReferencePrefixes.DocumentReference);
    },
    async performSearch(this: any) {
      try {
        this.isSearchRefreshing = true;
        this[StoreConstants.Search.Actions.ResetSearchResults]();
        const searchRequest = SearchCriteriaUtils.mapToSearchRequest(this[StoreConstants.Search.Getters.SearchCriteria]);
        this[StoreConstants.Search.Actions.SetSearchResponse](await ApiConfiguration.apiWithErrorPage().search.searchPerformsearchCreate(searchRequest));
        this.removeInvalidFilterOptions();
        this.removeInvalidSortOptions();
        this.initializeSearchVariables();
      } finally {
        this.isSearchRefreshing = false;
      }
    },
    removeInvalidFilterOptions(this: any) {
      if (!this.searchResults?.appliedFilterOptions?.length) {
        return;
      }
      this.filterOptions = this.searchResults.appliedFilterOptions.filter((option: TableFilterModel) => this.filteringFields.some((field: any) => field.key === option.key));
      this.applyFilters();
    },
    removeInvalidSortOptions(this: any) {
      if (!this.searchResults?.appliedSortOptions?.length) {
        return;
      }
      this.sortOptions = this.searchResults.appliedSortOptions.filter((option: TableSortModel) => this.filteringFields.some((field: any) => field.key === option.sortingKey));
      this.sortItems();
    },
    async initializeSearchVariables(this: any) {
      this.unsortedItems = this.searchResults.response.documents.map((item: SearchResultsDocumentModel) => {
        const { references, ...rest } = item;
        return {
          ...rest,
          ...references,
          documentDate: item.documentDate
        };
      });
      this[StoreConstants.Search.Actions.SetUnsortedItems](this.unsortedItems);
      this[StoreConstants.Search.Actions.SetSplitConfiguration](this[StoreConstants.UserPreferences.Getters.SearchSplitConfiguration]);
      this.fields = [{ key: 'actions', label: '', tdClass: 'w-0 align-middle no-resize', thClass: 'w-0 no-resize' }, ...this.searchResults.response.columns];
      if (!this.searchReturnedNoMatches) {
        this.documentBeingViewed = this.unsortedItems[0].documentId;
        const documentSearchModel: BaseDocumentSearchModel = {
          cabinetId: this.unsortedItems[0].cabinetId,
          documentId: this.documentBeingViewed,
          documentTypeId: this.unsortedItems[0].documentTypeId
        };
        this.setDocumentSearchModel(documentSearchModel);
        this[StoreConstants.Search.Actions.SetLastViewedDocument]({ cabinetId: this.unsortedItems[0].cabinetId, documentId: this.documentBeingViewed });
        this.retrieveDocumentActions();
        this.loadPage(1);
      }
      this.addSavedSearchModel.name = this[StoreConstants.Search.Getters.SearchResults].response.searchName;
    },
    async reinitializeSearchVariables(this: any) {
      try {
        this.isSearchRefreshing = true;
        this.unsortedItems = this.searchResults.unsortedItems;
        this.fields = [{ key: 'actions', label: '', tdClass: 'w-0 align-middle no-resize', thClass: 'w-0 no-resize' }, ...this.searchResults.response.columns];
        this.sortOptions = this.searchResults.appliedSortOptions;
        this.filterOptions = this.searchResults.appliedFilterOptions;
        if (!this.searchReturnedNoMatches) {
          this.documentBeingViewed = this.searchResults.documentId;
          this.setDocumentSearchModel({ cabinetId: this.searchResults.cabinetId, documentId: this.documentBeingViewed } as BaseDocumentSearchModel);
          this.retrieveDocumentActions();
          this.loadPage(1);
        }
        this.addSavedSearchModel.name = this[StoreConstants.Search.Getters.SearchResults].response.searchName;
      } finally {
        this.isSearchRefreshing = false;
      }
    },
    async performEditSearch(this: any, searchCriteria: SearchCriteriaModel) {
      this.isSearchRefreshing = true;
      if (this.savedSearchId) {
        this.$router.replace({ name: Search.Results.name, params: { savedSearchId: undefined } });
      }
      this.savedSearchName = undefined;
      this.handleColumnConfigurations(searchCriteria);
      this[StoreConstants.Search.Actions.SetSearchCriteria](searchCriteria);
      this[StoreConstants.ApplicationDirty.Actions.ResetApplicationDirtyState]();
      await this.performSearch();
      this.editSearch = false;
    },
    handleColumnConfigurations(this: any, newSearchCriteria: SearchCriteriaModel) {
      const currentSearchCriteria = this[StoreConstants.Search.Getters.SearchCriteria] as SearchCriteriaModel;
      const hasSameCabinets = newSearchCriteria.cabinets.length === currentSearchCriteria.cabinets.length && newSearchCriteria.cabinets.every((x) => currentSearchCriteria.cabinets.includes(x));
      if (!hasSameCabinets) {
        this[StoreConstants.Search.Actions.SetColumnOrders]([]);
      }

      const hasSameDocumentTypes =
        newSearchCriteria.documentTypes.length === currentSearchCriteria.documentTypes.length && newSearchCriteria.documentTypes.every((x) => currentSearchCriteria.documentTypes.includes(x));
      if (!hasSameDocumentTypes) {
        this[StoreConstants.Search.Actions.SetColumnOrders]([]);
      }
    },
    openDocumentViewerInNewTab(this: any, { cabinetId, documentTypeId, documentId }: any) {
      const documentSearchModel: BaseDocumentSearchModel = {
        cabinetId,
        documentTypeId,
        documentId
      };
      this.setDocumentSearchModel(documentSearchModel);
      this.retrieveDocumentActions();
      const route = this.$router.resolve({
        name: Search.DefaultDocumentView.name,
        params: { cabinetId, documentId }
      }).route.path;
      this.openInNewTab(route);
    },
    openWorkflowJobInNewTab(this: any, item: any) {
      this.openInNewTab(`/workflow/job/${item.queueId}/${item.jobId}`);
    },
    openWorkflowJob(this: any, item: any) {
      this.$router.push({
        path: `/workflow/job/${item.queueId}/${item.jobId}`
      });
    },
    openInNewTab(this: any, path: string) {
      const route = this.$router.resolve({ path });
      window.open(route.href, '_blank');
    },
    openDocumentView(this: any, item: any) {
      const documentSearchModel: BaseDocumentSearchModel = {
        cabinetId: item.cabinetId,
        documentId: item.documentId,
        documentTypeId: item.documentTypeId
      };
      this.setDocumentSearchModel(documentSearchModel);
      this.retrieveDocumentActions();
      this.$router.push({
        name: Search.DefaultDocumentView.name,
        params: { cabinetId: item.cabinetId, documentId: item.documentId }
      });
    },
    formatDate(this: any, value: any) {
      const date = new Date(value);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      return `${day}/${month}/${year}`;
    },
    onExportSelectedDocuments(this: any, includeRelatedDocuments: boolean = false) {
      this.backgroundComponent = this.BACKGROUND_COMPONENTS.BackgroundExport;
      this.includeRelatedDocuments = includeRelatedDocuments;
      this.setBulkDocumentsFromSelection();
    },
    onExportAllDocuments(this: any, includeRelatedDocuments: boolean = false) {
      this.backgroundComponent = this.BACKGROUND_COMPONENTS.BackgroundExport;
      this.includeRelatedDocuments = includeRelatedDocuments;
      this.setBulkDocumentsFromFilteredItems();
    },
    async onDeleteSelectedDocuments(this: any) {
      this.bulkDocuments = this.selectedBulkDocuments;

      if (
        await ModalHelpers.methods.showConfirmationModalAsync(this.$bvModal, `Are you sure you want to delete ${this.bulkDocuments.length} document${this.bulkDocuments.length > 1 ? 's' : ''}?`, {
          okVariant: ColourVariantType.Danger,
          cancelVariant: ColourVariantType.Primary,
          okTitle: ModalConstants.deleteConfirmationText
        })
      ) {
        this.backgroundComponent = this.BACKGROUND_COMPONENTS.BackgroundDelete;
        this.setBulkDocumentsFromSelection();
      }
    },

    async onDeleteAllDocuments(this: any) {
      if (
        await ModalHelpers.methods.showConfirmationModalAsync(this.$bvModal, 'Are you sure you want to delete all documents?', {
          okVariant: ColourVariantType.Danger,
          cancelVariant: ColourVariantType.Primary,
          okTitle: ModalConstants.deleteConfirmationText
        })
      ) {
        this.backgroundComponent = this.BACKGROUND_COMPONENTS.BackgroundDelete;
        this.setBulkDocumentsFromFilteredItems();
      }
    },
    setBulkDocumentsFromSelection(this: any) {
      if (this.selectedDocumentCount === 0) {
        return;
      }
      this.bulkDocuments = this.selectedBulkDocuments;
      this.isLinkActionActive = true;
    },
    setBulkDocumentsFromFilteredItems(this: any) {
      if (this.filteredSortedItemsCount === 0) {
        return;
      }
      this.bulkDocuments = this.filteredSortedItems;
      this.isLinkActionActive = true;
    },
    onLinkActionCompleted(this: any) {
      this.isLinkActionActive = false;
    },
    async onLinkActionRefreshSearch(this: any) {
      await this.performSearch();
    },
    async showBulkEmailModal(this: any) {
      if (!this.searchResults.selectedItemKeys.length || this.searchResults.selectedItemKeys.length > this.emailDocumentMaxCount) {
        return;
      }
      this.isBulkEmailLoading = true;
      this.isBulkEmailModalShown = true;
      try {
        this.bulkEmailModel.documents = (this.searchResults.selectedItemKeys as string[]).map((selectedDocumentId) => {
          const document = (this.searchResults.response as SearchResultsModel).documents!.find(({ documentId }) => documentId === Number(selectedDocumentId));
          return { cabinetId: document?.cabinetId, documentId: document?.documentId };
        });
        await ApiConfiguration.api().documentEmail.documentEmailValidateFileSizeLimitCreate((this.bulkEmailModel as DocumentBulkEmailModel).documents!);
      } catch {
        this.isBulkEmailModalShown = false;
      } finally {
        this.isBulkEmailLoading = false;
      }
    },
    async sendBulkEmail(this: any) {
      this.isBulkEmailProcessing = true;
      try {
        await ApiConfiguration.api().documentEmail.documentEmailBulkCreate({ ...this.bulkEmailModel });
        SnotifyConfiguration.showSuccess('Email successfully sent');
      } finally {
        this.isBulkEmailProcessing = false;
        this.isBulkEmailModalShown = false;
      }
    },
    async getEmailDocumentMaxCount(this: any) {
      this.emailDocumentMaxCount = Number(await ApiConfiguration.api().parameter.parameterList({ group: 'SYSTEM', code: 'EmailDocumentMaxCount', entityPk: '0', entityTypeId: 0 }));
    },
    setSplitConfigurationStore(this: any) {
      const updatedConfiguration = (this.searchResults.splitConfiguration + 1) % 3;
      this[StoreConstants.Search.Actions.SetSplitConfiguration](updatedConfiguration);
      this[StoreConstants.UserPreferences.Actions.SetSearchSplitConfiguration]({ splitConfiguration: updatedConfiguration });
    },
    async initialiseSavedSearch(this: any) {
      if (!this.savedSearchId) {
        return;
      }

      const savedSearch = await ApiConfiguration.api().search.searchSavedSearchesDetail(this.savedSearchId);

      const searchCriteria = JSON.parse(savedSearch.searchCriteria!);
      this[StoreConstants.Search.Actions.SetSearchCriteria]({ ...searchCriteria });
      this.savedSearchName = savedSearch.name;
    },
    async saveSearch(this: any) {
      this.isSavedSearchCreating = true;
      const { name, isPrivate, roleId } = this.addSavedSearchModel;
      try {
        const savedSearch = await ApiConfiguration.api().search.searchSavedSearchCreate({
          name,
          roleId: isPrivate ? null : roleId,
          searchCriteria: JSON.stringify(this[StoreConstants.Search.Getters.SearchCriteria])
        });
        SnotifyConfiguration.showSuccess('Search successfully saved');
        this.$refs.savedSearches.getSavedSearches();
        this.savedSearchName = savedSearch.name;
        this.$router.replace({ name: Search.Results.name, params: { savedSearchId: savedSearch.id } });
      } finally {
        this.isSavedSearchCreating = false;
        this.isSaveSearchModalShown = false;
      }
    },
    setActiveTab(this: any, tabNumber: number) {
      this.activeTab = tabNumber;
    },
    openSavedSearches(this: any) {
      this.setActiveTab(1);
      this.editSearch = true;
    },
    openEditSearch(this: any) {
      this.setActiveTab(0);
      this.editSearch = true;
    },
    onExportToCsv(this: any) {
      this.isExportingToCsv = true;
    },
    onCsvExportSuccessful(this: any) {
      this.isExportingToCsv = false;
      SnotifyConfiguration.showSuccess('Table data exported successfully');
    },
    onCsvExportFailed(this: any, error: any) {
      SnotifyConfiguration.showError(error);
    },
    onCsvExportCancelled(this: any) {
      this.isExportingToCsv = false;
    }
  },
  async mounted(this: any) {
    if (!this.savedSearchId && this[StoreConstants.Search.Getters.SearchCriteria]?.userId !== this[StoreConstants.Oidc.Getters.OidcUser].id) {
      this.$router.push({ name: Search.Criteria.name });
      return;
    }

    await this.initialiseSavedSearch(this.savedSearchId);
    this.userRoles = await ApiConfiguration.api().users.usersCurrentUserRolesList();

    this.getEmailDocumentMaxCount();
    try {
      if (this.previousRoute.currentRoute.name !== 'documentView' || !(this[StoreConstants.Search.Getters.SearchResults] as SearchTableStateModel).response || this.refresh) {
        this[StoreConstants.Search.Actions.UnloadSearchResults]();
        await this.performSearch();
      } else {
        await this.reinitializeSearchVariables();
      }
    } finally {
      this.isLoading = false;
    }
  },
  created(this: any) {
    this.valueType = ValueType;
    this.BACKGROUND_COMPONENTS = { BackgroundExport: 'BackgroundExport', BackgroundDelete: 'BackgroundDelete' };
    this.IS_TOUCHSCREEN = window.matchMedia('(any-pointer: coarse)').matches;
  },
  components: {
    MStoreTable,
    MStoreColumnFilter,
    MStoreColumnConfiguration,
    MStoreSplitter,
    DocumentViewer,
    LoadingSpinner,
    PopOutSideBar,
    SearchBuilder,
    BackgroundExport: () => import('@/components/document/BackgroundExport.vue'),
    BackgroundDelete: () => import('@/components/document/BackgroundDelete.vue'),
    MStoreSpinnerButton,
    MStoreFormInput,
    MStoreFormTextarea,
    MStoreFormSelect,
    MStoreSavedSearches,
    MStoreExportToCsv: () => import('@/components/shared/MStoreExportToCsv.vue'),
    DocumentPrint: () => import('@/components/document/DocumentPrint.vue')
  }
});
